import { gql } from '@apollo/client';

export const CREATE_RANGE_APPOINTMENT = gql`
  mutation CreateRangeAppointment(
    $record: PractitionerCreateAppointmentInput!
  ) {
    schedule {
      createAppointment(record: $record) {
        ok
        error {
          code
          message
        }
        resultId
        result {
          id
          title
          isOnline
          eventType
          possibleDateRange
          planifiedDuration
          startDate
          endDate
          updatedAt
          note
          status
          files {
            id
            url
            title
          }
          patientParticipant {
            patient {
              id
              name {
                firstName
                lastName
              }
              birthDate
              email
              phone
              gender
              birthDate
              birthPlace {
                country
                city
                address
                zipcode
              }
            }
            status
          }
          practitionerParticipants {
            practitioner {
              id
              firstName
              lastName
              email
              phone
              birthDate
              gender
              birthDate
              photoUrl
              preferredLanguages
              professionalNumber
              specialities
            }
            status
          }
        }
      }
    }
  }
`;
